export const CONTEXT_STORAGE_KEY = 'koddi-one-context';
